import { openWorkspaceDb } from '@/offline/db'
import { atomicLocalWrite, buildOperation } from '@/offline/queue'
import { pushOutbox, type PushSummary } from '@/offline/sync'
import { supabaseTransport } from '@/offline/transport'
import type { BuiltPurchase } from './purchasePayload'

/**
 * Save a purchase locally (device + IMEIs + purchase in ONE IndexedDB transaction
 * together with its outbox operation), then attempt to sync it to the server.
 * If offline, the record stays local and the op remains queued for a later push.
 */
export async function savePurchase(workspaceId: string, built: BuiltPurchase): Promise<PushSummary> {
  const db = openWorkspaceDb(workspaceId)

  const op = buildOperation({
    workspace_id: workspaceId,
    entity_id: built.device.id,
    entity_type: 'device',
    expected_revision: null,
    action: 'purchase.create',
    payload: built.payload,
  })

  await atomicLocalWrite(
    db,
    [db.devices, db.device_imeis, db.purchases],
    async () => {
      await db.devices.add(built.device)
      if (built.imeis.length > 0) await db.device_imeis.bulkAdd(built.imeis)
      await db.purchases.add(built.purchase)
    },
    op,
  )

  return pushOutbox(db, supabaseTransport())
}
